import React from 'react';
import { useLoginContext } from '../../Contexts/LoginContext';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import Button from '../Form/Button';
import { TbUserQuestion } from 'react-icons/tb';
import { useLoginHook } from '../../Hooks/LoginHook';

interface ButtonLoginProps {
    className?: string;
    asButtonGray?: boolean;
    labelLink?: string;
    forceSsoLogin?: boolean;
    withLoading?: boolean
    hideLabelOnMobile?: boolean;
}

const ButtonLogin = ({
    className,
    asButtonGray = false,
    labelLink,
    forceSsoLogin = false,
    withLoading = false,
    hideLabelOnMobile = false,

}: ButtonLoginProps) => {

    const { isAuthenticated, setShowLoginBasic, setShowButtonQuickPurchase } = useLoginContext();
    const { company } = useLayoutContext();
    const { handleRedirectSSO } = useLoginHook();

    const handleClick = () => {
        if (forceSsoLogin && company?.sso_active) {
            handleRedirectSSO();
        } else {
            setShowButtonQuickPurchase(false);
            setShowLoginBasic(true);
        }
    }

    if (!company || isAuthenticated) return null;

    return (
        <Button
            outline
            gray={asButtonGray}
            onClick={handleClick} 
            withLoading={withLoading}
            className={`
                ${className}
                ${hideLabelOnMobile ? 'max-lg:aspect-square max-lg:max-w-11' : ''}
                relative justify-center items-center
                min-h-max
                flex gap-3
            `}
        >
            <span className="flex items-center gap-1 leading-none">
                <TbUserQuestion size={hideLabelOnMobile ? 20 : undefined} className='shrink-0' />
                <div className={hideLabelOnMobile ? 'hidden lg:block' : ''}>{labelLink}</div>
            </span>
        </Button>
    )


}

export default ButtonLogin;